export default __webpack_public_path__ + "static/media/MaskGroup-3.fa53cbdc.svg";